const TITLE = 'SevenAfter | A Day with Amara'
const DESCRIPTION =
  'Enter Savanna City. Notice the clues, check the story, and choose a safer path in this interactive SevenAfter demo.'

const FAVICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><circle cx="16" cy="16" r="15" fill="#174C4F"/><path d="M16 24V12" stroke="#B6C879" stroke-width="2.4" stroke-linecap="round"/><ellipse cx="11.5" cy="14" rx="5" ry="2.4" fill="#B6C879" transform="rotate(-30 11.5 14)"/><ellipse cx="20.5" cy="11" rx="5" ry="2.4" fill="#DDA24A" transform="rotate(30 20.5 11)"/></svg>`

function ensureElement<T extends HTMLElement>(selector: string, create: () => T): T {
  const existing = document.head.querySelector<T>(selector)
  if (existing) return existing
  const element = create()
  document.head.appendChild(element)
  return element
}

export function applyDocumentMeta() {
  document.title = TITLE
  const description = ensureElement('meta[name="description"]', () => {
    const meta = document.createElement('meta')
    meta.setAttribute('name', 'description')
    return meta
  })
  description.setAttribute('content', DESCRIPTION)

  const icon = ensureElement('link[rel="icon"]', () => {
    const link = document.createElement('link')
    link.setAttribute('rel', 'icon')
    return link
  })
  icon.setAttribute('type', 'image/svg+xml')
  icon.setAttribute('href', `data:image/svg+xml,${encodeURIComponent(FAVICON_SVG)}`)
}
